
















import Vue from 'vue';

export default Vue.extend({
  name: 'SearchBar',
  props: {
    populate: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      search: this.populate,
    };
  },
  methods: {
    onSearchChange() {
      if (this.populate !== this.search && this.search.length) {
        this.$emit('searchChanged', this.search);
      } else if (!this.search.length) {
        this.$emit('searchChanged', null);
      }
    },
  },
});
